import React from 'react';
import Wrapper from '../components/layout/Wrapper';
import App from '../components/layout/App';

const IndexPage = () => {
  return (
    <App>
      <Wrapper>
        <h1>Hello World</h1>
      </Wrapper>
    </App>
  );
};

export default IndexPage;
